import styled from 'styled-components';

import { SectionStyledProps } from './types';
import { SectionBackgroundMode } from './enums';

import { Box } from '../../styles/Grid/styles';

export const Section = styled(Box)<SectionStyledProps>`
  margin: 0 auto;
  background-color: ${({ theme, backgroundMode }) =>
    (backgroundMode === SectionBackgroundMode.Default && 'transparent') ||
    (backgroundMode === SectionBackgroundMode.Grey && theme.colors.additional.accentGray3) ||
    (backgroundMode === SectionBackgroundMode.White && theme.colors.additional.background) ||
    (backgroundMode === SectionBackgroundMode.LightBlue && theme.colors.primary.surface)};
`;
